<app-sidebar
  [onboarding]="onboarding"
></app-sidebar>

<div class="creator-layout">
  <div class="sidebar-placeholder"></div>
  <div class="content">
    <router-outlet></router-outlet>

    <app-modal
      [open]="showAnnouncementModal"
      [modalClass]="'modal--without-header announcement-modal'"
      (closed)="closeAnnouncementModal()"
    >
      <img modal-image [src]="getImageSrc()" alt="{{'calendar.announcement-modal.title'|transloco}}"
           class="announcement-modal__image"
      />
      <div modal-body>
        <div class="announcement-modal__tag tag tag--green">
          <i class="fa-solid fa-certificate"></i>
          <p>{{'sidebar.new'|transloco}}</p>
        </div>
        <h2>{{'calendar.announcement-modal.title'|transloco}}</h2>
        <p class="announcement-modal__content">{{'calendar.announcement-modal.content'|transloco}}</p>
      </div>
      <div modal-footer>
        <div class="announcement-modal__actions">
          <button class="button"
                  (click)="redirectToFeature()"
          >
            {{'calendar.announcement-modal.cta'|transloco}}
            <i class="fa-solid fa-arrow-right"></i>
          </button>
        </div>
      </div>
    </app-modal>
  </div>
</div>


